import posthog from 'posthog-js';

const isEnabled = () =>
  !import.meta.env.DEV && !!import.meta.env.VITE_POSTHOG_KEY;

export function initAnalytics() {
  if (!isEnabled()) return;

  posthog.init(import.meta.env.VITE_POSTHOG_KEY, {
    api_host: import.meta.env.VITE_POSTHOG_HOST || 'https://eu.i.posthog.com',
    autocapture: true,
    capture_pageview: true,
    capture_pageleave: true,
    persistence: 'memory',
  });
}

export function identifyUser(userId: string, properties?: Record<string, any>) {
  if (!isEnabled()) return;
  posthog.identify(userId, properties);
}

export function resetUser() {
  if (!isEnabled()) return;
  posthog.reset();
}

export function trackEvent(event: string, properties?: Record<string, any>) {
  if (!isEnabled()) return;
  posthog.capture(event, properties);
}

// Funnel events
export const analytics = {
  signupCompleted: (userId: string, method: 'email' | 'invitation' | 'google') =>
    trackEvent('signup_completed', { user_id: userId, method }),

  storyCreated: (storyId: string, properties?: { title?: string; relationship?: string; mode?: string }) =>
    trackEvent('story_created', { story_id: storyId, ...properties }),

  recordingCompleted: (properties: { storyQuestionId: string; chapterId: string; durationMs: number }) =>
    trackEvent('recording_completed', properties),

  chapterCompleted: (storyId: string, chapterId: string, chapterTitle: string) =>
    trackEvent('chapter_completed', { story_id: storyId, chapter_id: chapterId, chapter_title: chapterTitle }),

  memoirGenerated: (storyId: string, memoirId: string, properties?: { totalChapters?: number; completedChapters?: number }) =>
    trackEvent('memoir_generated', { story_id: storyId, memoir_id: memoirId, ...properties }),
};
